import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'

export interface State {
  entityId: number
  entityType: ENTITY_TYPES
  locations: LocationDTO[]
}

export type ResetFromPropsAction = {
  type: 'RESET_FROM_PROPS'
  payload: {
    entityId: number
    entityType: ENTITY_TYPES
    locations?: LocationDTO[]
  }
}

export type Action = ResetFromPropsAction

export type InitArg = {
  entityId: number
  entityType: ENTITY_TYPES
  locations?: LocationDTO[]
}

export function init(params: InitArg): State {
  const { entityId, entityType, locations } = params

  return {
    entityId,
    entityType,
    locations: locations ?? [],
  }
}

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'RESET_FROM_PROPS':
      return {
        ...state,
        entityId: action.payload.entityId,
        entityType: action.payload.entityType,
        locations: action.payload.locations ?? [],
      }
    default:
      return state
  }
}
